import {getCardInfo} from '@/service/card'


 interface CoreState{
  token: string;
  active: number;
  userInfo: any;
  cardInfo: any;
}

 interface CoreType{
  namespaced: boolean;
  state: CoreState;
  mutations: any;
  actions: any;
  modules: any;
}

const core: CoreType = {
  namespaced: true,
  state:{
    token: '',
    active: 0,
   userInfo: null,
   cardInfo: null
  },
  mutations: {
    settoken(state: any, payload: any){
      state.token = payload.data
    },
    setUserInfo(state: any,payload: any){
      state.userInfo=payload.data
    },
    setCardInfo(state: any){
      getCardInfo().then(res => {
        state.cardInfo = res.data
      })
      
    },
    clearSate(state: any){
      state.token = ""
      state.userInfo={}
    },
    setActiveTab(state: any, ac: number) {
      state.active = ac
    }
  },
  actions: {},
  modules: {}
}

export default core